import { Box, Flex, Modal, ModalContext, Text } from 'dash-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { WeekDays } from 'dash-common';
import moment from 'moment';
import { useContext } from 'react';

//TODO: Fix the type here, using graphql Broker does not work, even though thats the type
const BrokerAvailabilityModal = ({
  broker,
}: {
  broker: Record<string, any>;
}) => {
  const { t } = useTranslation('pages');
  const theme = useTheme();

  const { isOpenCurrent, toggleModal } = useContext(ModalContext);

  const isOpen = isOpenCurrent['BrokerAvailabilityModal'];
  const closeModal = () => {
    toggleModal(false, 'BrokerAvailabilityModal');
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t('pages:portfoliosPage.availability') || ''}
      onRequestClose={closeModal}
      closeIcon={true}
    >
      {Object.values(WeekDays).map((day, index) => {
        const range = (broker.workingHours || {})[day];
        const from = moment(range?.from).format('hh:mm A');
        const to = moment(range?.to).format('hh:mm A');

        return (
          <Flex key={day} alignItems="center" mt={index === 0 ? 0 : 3.5}>
            <Box mr={2} w={40}>
              <Text whiteSpace="nowrap">
                {t(`common:labels.weekDays.${day}`).slice(
                  0,
                  day === WeekDays.Tuesday ? 4 : 3
                )}
                :
              </Text>
            </Box>
            <Text
              whiteSpace="nowrap"
              sm
              color={!range ? theme.colors.r20 : theme.colors.b50}
            >
              {!range ? t('common:labels.notWorking') : `${from} - ${to}`}
            </Text>
          </Flex>
        );
      })}
    </Modal>
  );
};

export default BrokerAvailabilityModal;
